import { Component, Input } from '@angular/core';
import { AppConfig } from 'client/app/app.config';

@Component({
  selector: 'missed-doctor-call',
  templateUrl: './missed-doctor-call.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class MissedDoctorCallComponent {
  @Input() userFirstName: string = '';
  constructor(
    public appConfig: AppConfig,
  ) { }
}
